"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPane = void 0;
var SplitPane_1 = require("./lib/SplitPane");
Object.defineProperty(exports, "SplitPane", { enumerable: true, get: function () { return SplitPane_1.SplitPane; } });
//# sourceMappingURL=index.js.map